export enum CalendarType {
    Month = 'dayGridMonth',
    ListMonth = 'listMonth',
    ListDay = 'listDay',
    ListWeek = 'listWeek'
}